import React from "react";
import { FlexibleLayoutCSS } from "./components/layouts/FlexibleLayoutCSS";
import "./styles/globals.css";

const App = () => {
  return (
    <div style={{
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden'
    }}>
      <div style={{
        flex: 1,
        overflow: 'auto',
        minHeight: 0
      }}>
        <FlexibleLayoutCSS
          initialMapData={{
            latitude: 33.6844,
            longitude: 73.0479,
            crop_type: "wheat",
            area: 1.0,
          }}
          hideRightPanelUntilData={true}
        />
      </div>


      <footer style={{
        backgroundColor: '#2a537c',
        color: 'white',
        textAlign: 'center',
        padding: '5px 0',
        fontSize: '14px',
        flexShrink: 0
      }}>
        © 2025 International Water Management Institute (IWMI). All rights reserved.
      </footer>
    </div>
  );
};

export default App;
